(function () {
  var root = document.querySelector('[data-tcb-safety-compliance]');
  if (!root) return;

  var filterBtns = root.querySelectorAll('[data-sc-filter]');
  var cards = root.querySelectorAll('[data-sc-resource]');
  var emptyEl = root.querySelector('[data-sc-empty]');
  var countEl = root.querySelector('[data-sc-count]');
  var searchInput = root.querySelector('[data-sc-search]');
  var topicSelect = root.querySelector('[data-sc-topic-filter]');
  var typeSelect = root.querySelector('[data-sc-type-filter]');
  var searchForm = root.querySelector('[data-sc-search-form]');
  var activeFilter = 'all';
  var activeType = 'all';

  function norm(value) {
    return (value || '').toLowerCase().trim();
  }

  function applyFilters() {
    var query = searchInput ? norm(searchInput.value) : '';
    var visible = 0;

    cards.forEach(function (card) {
      var categories = norm(card.getAttribute('data-categories')).split(/\s+/).filter(Boolean);
      var title = norm(card.getAttribute('data-title'));
      var excerpt = norm(card.getAttribute('data-excerpt'));
      var type = norm(card.getAttribute('data-type'));
      var categoryMatch = activeFilter === 'all' || categories.indexOf(activeFilter) !== -1;
      var typeMatch = activeType === 'all' || type === activeType;
      var searchMatch = !query || title.indexOf(query) !== -1 || excerpt.indexOf(query) !== -1;
      var show = categoryMatch && typeMatch && searchMatch;

      card.hidden = !show;
      if (show) visible += 1;
    });

    if (emptyEl) emptyEl.hidden = visible > 0;
    if (countEl) countEl.textContent = visible + ' resources';
  }

  function setActiveFilter(nextFilter) {
    activeFilter = nextFilter || 'all';

    filterBtns.forEach(function (btn) {
      var btnFilter = btn.getAttribute('data-sc-filter') || 'all';
      var isActive = btnFilter === activeFilter;
      btn.classList.toggle('is-active', isActive);
      if (btn.classList.contains('tcb-sc-topic')) {
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
    });

    if (topicSelect) {
      topicSelect.value = activeFilter === 'all' ? 'all' : activeFilter;
    }

    applyFilters();
  }

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      if (btn.tagName === 'A' && btn.getAttribute('href') === '#tcb-sc-all-resources') {
        event.preventDefault();
      }
      setActiveFilter(btn.getAttribute('data-sc-filter'));
      var target = root.querySelector('#tcb-sc-all-resources');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (topicSelect) {
    topicSelect.addEventListener('change', function () {
      setActiveFilter(topicSelect.value || 'all');
    });
  }

  if (typeSelect) {
    typeSelect.addEventListener('change', function () {
      activeType = typeSelect.value || 'all';
      applyFilters();
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
      var query = searchInput && searchInput.value.trim();
      if (query && emptyEl && emptyEl.hidden === false) {
        window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=article';
      }
    });
  }

  if (searchInput) searchInput.addEventListener('input', applyFilters);

  applyFilters();
})();
